import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AppUser, Restaurant, Role } from '@/types/app'

interface AuthState {
  user: AppUser | null
  restaurant: Restaurant | null
  role: Role | null
  isLoading: boolean
  setUser: (user: AppUser) => void
  setRestaurant: (restaurant: Restaurant) => void
  setLoading: (loading: boolean) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      restaurant: null,
      role: null,
      isLoading: true,
      setUser: (user) => set({ user, role: user.role }),
      setRestaurant: (restaurant) => set({ restaurant }),
      setLoading: (isLoading) => set({ isLoading }),
      clear: () => set({ user: null, restaurant: null, role: null, isLoading: false }),
    }),
    {
      name: 'rezzops-auth',
      partialize: (state) => ({ user: state.user, restaurant: state.restaurant, role: state.role }),
    }
  )
)
